// extracted by mini-css-extract-plugin
export default {"skeletonContainer":"Skeleton_skeletonContainer__FFa3u","fadeIn":"Skeleton_fadeIn__sJsge","spinner":"Skeleton_spinner__INAPh","rotate":"Skeleton_rotate__FBdZN"};